module.exports = __webpack_public_path__ + "static/media/Stellar Ark King Headboard - 180 cm_Light Beige.00a5620e.png";